// Angular / Core
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// Model
import { ApiResponse } from "@core/models/api-response.model";
import { Pagination } from "@core/models/pagination.model";
// Third Party
import { Observable, Subject } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable()
export class MetaTagDataService {

    pagination: Pagination;
    messages$ = new Subject<any[]>();

    constructor(private http: HttpClient) { }

    getWithQuery(params: string): Observable<[]> {
        return this.http.get<ApiResponse>(`/seo/getMetatagSettings${params}`).pipe(
            tap(res => this.paginationInit(res)),
            map(res => res.data.rows)
        );
    }

    add(data: any) {
        return this.http.post<ApiResponse>(`/seo/metatags`, data);
    }

    update(id: number, data: any) {
        return this.http.put<ApiResponse>(`/seo/metatags/${id}`, data).pipe(
            tap(res => this.messages$.next(res.message))
        )
    }

    private paginationInit(res: any) {
        if (res) {
            this.pagination = res.data.paginations;
        }
    }

}
